export default __webpack_public_path__ + "static/media/gamesDBTemplateIcon.c85ad85f.svg";